import { combineReducers } from 'redux';
import contactReducer from './contactReducer';
import scanReducer from './scanReducer';
import subscribeReducer from './subscribeReducer';

export default combineReducers({
  contact: contactReducer,
  scan: scanReducer,
  subscribe: subscribeReducer,
});
